<script>
import CustomFieldType from './CustomFieldType';
import DatePicker from '../../global/form/DatePicker';
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';

export default {
    props: {
        field: {
            required: true,
            type: Object,
        },

        value: {
            required: false,
            default: '',
        },

        error: {
            required: false,
            default: null
        },

        usePlaceholder: {
            required: false,
            default: false,
        },

        displayStyle: {
            default: 'default',
        },

        showRequiredIndicator: {
            default: false,
        },
    },

    data() {
        return {
            CustomFieldType
        }
    },

    methods: {
        toggleCheckboxValue(checkboxValue) {
            const currentValues = this.value || [];

            if (currentValues.includes(checkboxValue)) {
                this.$emit('input', currentValues.filter(v => v !== checkboxValue));
            } else {
                this.$emit('input', [...currentValues, checkboxValue]);
            }
        },

        isSelected(value) {
            return this.value === value || (this.value || []).includes(value);
        }
    },

    computed: {
        fieldChoices() {
            if ([CustomFieldType.Radio, CustomFieldType.Checkbox].includes(this.field.type)) {
                const fieldChoices = this.field.field_choices.map(c => c.choice);
                const value = typeof this.value === 'object' && this.value.length > 0
                    ? [...this.value]
                    : (!isEmpty(this.value) ? [this.value] : []);
                return uniq([...fieldChoices, ...value]);
            }

            return [];
        }
    },

    components: {
        DatePicker,
    },
}
</script>

<template>
    <div class="form-group" :class="{ 'has-error': !!error }">
        <label v-if="!usePlaceholder"
            :for="field.identifier"
            class="control-label"
            :class="{ 'col-sm-2': displayStyle === 'inline' }"
        >{{ field.name }}  <span class="text-danger" v-if="showRequiredIndicator">*</span> </label>

        <div :class="{ 'col-sm-10': displayStyle === 'inline' }">
            <input v-if="field.type === CustomFieldType.Text"
                :value="value"
                @input="$emit('input', $event.target.value)"
                type="text"
                :id="field.identifier"
                :name="field.identifier"
                :placeholder="usePlaceholder ? field.name : ''"
                class="form-control">

            <textarea v-if="field.type === CustomFieldType.Textarea"
                :value="value"
                @input="$emit('input', $event.target.value)"
                :id="field.identifier"
                :name="field.identifier"
                :placeholder="usePlaceholder ? field.name : ''"
                class="form-control"
            ></textarea>

            <input v-if="field.type === CustomFieldType.Number"
                :value="value"
                @input="$emit('input', $event.target.value)"
                type="number"
                :id="field.identifier"
                :name="field.identifier"
                :placeholder="usePlaceholder ? field.name : ''"
                class="form-control">

            <template v-if="field.type === CustomFieldType.Date">
                <div :class="{'input-group' : value}">
                    <date-picker
                                :id="field.identifier"
                                :name="field.identifier"
                                :value="value"
                                @input="$emit('input', $event)"
                                :placeholder="usePlaceholder ? field.name : ''"
                    ></date-picker>
                    <span class="input-group-btn" v-if="value">
                        <a class="btn btn-default" href="" @click.prevent="$emit('input', '')"><i class="zmdi zmdi-close"></i></a>
                    </span>
                </div>
            </template>

            <template v-if="field.type === CustomFieldType.Radio && fieldChoices && fieldChoices.length > 0">
                <select :id="field.identifier"
                        :name="field.identifier"
                        :value="value"
                        @input="$emit('input', $event.target.value)"
                        class="form-control"
                >
                    <option :value="null">{{ trans('surveys.please_select') }}</option>
                    <option v-for="(choice, index) in fieldChoices" :key="index"
                            :value="choice"
                    >{{ choice }}</option>
                </select>
            </template>

            <template v-if="field.type === CustomFieldType.Checkbox && fieldChoices && fieldChoices.length > 0">
                <div class="mt-3">
                    <label class="flex items-start mb-2"
                           v-for="(choice, index) in fieldChoices"
                           :key="choice"
                           @click.prevent="toggleCheckboxValue(choice)"
                    >
                        <i class="fa mt-2" style="min-width: 15px;"
                           :class="{ 'fa-check-square-o': isSelected(choice), 'fa-square-o': !isSelected(choice) }"
                        ></i>
                        <span class="ml-5 font-normal">{{ choice }}</span>
                    </label>
                </div>
            </template>

            <span class="help-block" v-if="error">{{ error }}</span>
        </div>
    </div>
</template>
